export const pushToDataLayer = (event, fieldName, fieldValue) => {
  if (typeof window !== 'undefined' && window?.dataLayer) {
    window.dataLayer.push({ event, fieldName, fieldValue });
  }
};

// The new structure for the events on this ticket: https://dept-uk.atlassian.net/browse/SJPSUP-1904
// requires a new function to avoid having to change the data layer events everywhere else on the site
// currently 80+ instances where it is already used and I don't think we should be altering this
export const eventToDataLayer = (event, obj) => {
  if (typeof window !== 'undefined' && window?.dataLayer) {
    window.dataLayer.push({ event, ...obj });
  }
};

// we may possibly need to add more into here, this is taking the icon name from the contact link and deciding an event name for it
export const contactEventStrings = {
  email: 'contact_mail_click',
  phone: 'contact_tel_click',
  mobile: 'contact_tel_click',
};

export const formStepStrings = {
  1: 'your details',
  2: 'your enquiry',
  3: 'confirmation',
};
